module.exports = __webpack_public_path__ + "img/varghese.ab03d1be.jpg";